<template>
  <div class="content">
    <NuxtLoadingIndicator :height="3" color="var(--accent-primary)" />
    <base-header />
    <main class="wrapper">
      <map-sidebar :items="sidebarItems" />
      <NuxtPage />
    </main>
    <div v-if="useUserStore.role === 'admin'" class="admin-mode">
      You're in admin mode. All info on pages might look different than for
      default users. Please mind that.
    </div>
    <base-cookie-pop-up />
  </div>
  <Teleport v-if="isGtmEnabled" to="body">
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WPMLJH26"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
  </Teleport>
</template>

<script setup lang="ts">
import { userStore } from "~/store/user";
import eventBus from "~/utilities/composables/eventBus";
import type { UnitResponseDTO } from "~/services/swagger/Api";

const useUserStore = userStore();
const $q = useQuasar();
const nuxtApp = useNuxtApp();
const route = useRoute();

// GTM is enabled only on production — mirrors plugins/gtm.js gating.
const config = useRuntimeConfig();
const isGtmEnabled = computed(
  () => config.public.NUXT_SITE_ENV === "production",
);

const checkUser = async () => {
  const token = useCookie("acc_token");
  if (!token.value) return;
  const res = await useUserStore.checkAccTokenExp(token.value);
  if (!res) return;
  if (route.path === "/profile") return;
  useUserStore.fetchUserData();
};

nuxtApp.hooks.hookOnce("page:start", async () => {
  const { proxy } = useScriptHotjar({
    id: 5060044,
  });
  proxy.hj("identify", 5060044, {});
  if (route.path === "/directory") return;
});

const sidebarItems = ref<UnitResponseDTO[]>([]);

const handleMapViewportChange = (val: UnitResponseDTO[]) => {
  sidebarItems.value = val;
};

onMounted(() => {
  checkUser();
  useUserStore.createUserUID();
  eventBus.on("map-viewport-change", handleMapViewportChange);
});
</script>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--white-contrast);
  .admin-mode {
    position: fixed;
    top: 30px;
    left: 30px;
    padding: 10px;
    background-color: var(--violet-40);
    border-radius: 10px;
    opacity: 0.3;
    max-width: 150px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
